import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';
import GuestLanding from './GuestLanding';

/** "/" — the community feed for signed-in divers, the public landing page for everyone else. */
const HomeRoute: React.FC = () => {
  const [signedIn, setSignedIn] = useState(() => authService.isAuthenticated());

  useEffect(() => authService.subscribe(() => setSignedIn(authService.isAuthenticated())), []);

  return signedIn ? <Navigate to="/feed" replace /> : <GuestLanding />;
};

export default HomeRoute;
